class ProductImages extends HTMLElement {
  connectedCallback() {
    if (this.__pg_init) return
    this.__pg_init = true

    this.slideshow = this.querySelector('[data-product-photos]')
    if (!this.slideshow) return

    this.slides = Array.from(this.slideshow.querySelectorAll('.product-main-slide'))
    if (!this.slides.length) return

    this.thumbsWrap = this.querySelector('[data-product-thumbs]')
    this.thumbs = this.thumbsWrap ? Array.from(this.thumbsWrap.querySelectorAll('[data-product-thumb]')) : []

    this.activeIndex = this.getInitialIndex()
    this.applyActive(this.activeIndex)

    if (this.thumbsWrap && this.thumbs.length) {
      this.onThumbClick = (e) => {
        const a = e.target && e.target.closest ? e.target.closest('[data-product-thumb]') : null
        if (!a) return
        e.preventDefault()

        const idx = this.getThumbIndex(a)
        if (idx === -1) return
        this.applyActive(idx)
      }

      this.thumbsWrap.addEventListener('click', this.onThumbClick, { passive: false })
    }
  }

  disconnectedCallback() {
    if (this.thumbsWrap && this.onThumbClick) {
      this.thumbsWrap.removeEventListener('click', this.onThumbClick)
    }
    this.__pg_init = false
  }

  getInitialIndex() {
    const starting = this.slides.findIndex((s) => s.classList.contains('starting-slide'))
    if (starting >= 0) return starting

    const featuredId = this.getFeaturedMediaId()
    if (featuredId) {
      const byId = this.slides.findIndex((s) => String(s.getAttribute('data-media-id') || '') === String(featuredId))
      if (byId >= 0) return byId
    }

    return 0
  }

  getFeaturedMediaId() {
    if (!this.thumbs || !this.thumbs.length) return null
    const featuredThumb = this.thumbs.find((t) => t.classList.contains('is-active') || t.getAttribute('aria-current') === 'true')
    if (!featuredThumb) return null
    const id = featuredThumb.getAttribute('data-id')
    return id || null
  }

  getThumbIndex(a) {
    const idxAttr = a.getAttribute('data-index')
    if (idxAttr !== null && idxAttr !== '') {
      const n = parseInt(idxAttr, 10)
      if (!Number.isNaN(n)) return n
    }

    const id = a.getAttribute('data-id')
    if (id) {
      const byId = this.slides.findIndex((s) => String(s.getAttribute('data-media-id') || '') === String(id))
      if (byId >= 0) return byId
    }

    const idx = this.thumbs.indexOf(a)
    if (idx >= 0 && idx < this.slides.length) return idx

    return -1
  }

  applyActive(index) {
    if (index < 0 || index >= this.slides.length) index = 0
    this.activeIndex = index

    for (let i = 0; i < this.slides.length; i++) {
      const slide = this.slides[i]
      if (i === index) {
        slide.style.display = ''
        slide.classList.add('is-active')
        this.forceVisible(slide)
      } else {
        slide.style.display = 'none'
        slide.classList.remove('is-active')
      }
    }

    for (let i = 0; i < this.thumbs.length; i++) {
      const t = this.thumbs[i]
      if (i === index) {
        t.classList.add('is-active')
        t.setAttribute('aria-current', 'true')
      } else {
        t.classList.remove('is-active')
        t.removeAttribute('aria-current')
      }
    }

    this.dispatchEvent(
      new CustomEvent('product-gallery:change', {
        bubbles: true,
        detail: { index: this.activeIndex }
      })
    )
  }

  forceVisible(slide) {
    const islands = slide.querySelectorAll('is-land')
    for (const island of islands) {
      if (!island.hasAttribute('ready')) island.setAttribute('ready', '')
    }

    const imgs = slide.querySelectorAll('img')
    for (const img of imgs) {
      img.style.opacity = '1'
      img.style.visibility = 'visible'
    }
  }
}

if (!customElements.get('product-images')) {
  customElements.define('product-images', ProductImages)
}

export default ProductImages
